module.exports = __webpack_public_path__ + "static/media/majorE7.4104dde.wav";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/sing/majorE7.wav
// module id = wcc8
// module chunks = 0